import { render } from "./OccupationDiseaseEdit.vue?vue&type=template&id=110943fb&scoped=true"
import script from "./OccupationDiseaseEdit.vue?vue&type=script&lang=js"
export * from "./OccupationDiseaseEdit.vue?vue&type=script&lang=js"

import "./OccupationDiseaseEdit.vue?vue&type=style&index=0&id=110943fb&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-110943fb"]])

export default __exports__